export type ThrowDirection = 'down' | 'left' | 'right' | 'up'

const THROW_DIRECTION_ROW: Readonly<Record<ThrowDirection, number>> = {
  down: 0,
  left: 1,
  right: 2,
  up: 3,
}

const THROW_MUZZLE: Readonly<Record<ThrowDirection, Readonly<{ x: number; y: number }>>> = {
  down: { x: 47, y: -60 },
  left: { x: -50, y: -84 },
  right: { x: 50, y: -84 },
  up: { x: 35, y: -108 },
}

export function resolveThrowDirection(dx: number, dy: number): ThrowDirection {
  if (Math.abs(dx) > Math.abs(dy)) return dx < 0 ? 'left' : 'right'
  return dy < 0 ? 'up' : 'down'
}

export function getDirectionalThrowFrame(direction: ThrowDirection, poseFrame: number): number {
  return THROW_DIRECTION_ROW[direction] * 4 + Math.max(0, Math.min(3, poseFrame))
}

export function getThrowMuzzle(direction: ThrowDirection): Readonly<{ x: number; y: number }> {
  return THROW_MUZZLE[direction]
}
